<template>
    <div class="Index">
        <allThead :title="title" @handleToggleTab="handleToggleTab" @handleLogin="handleLogin"/>

        <!-- 在线咨询 -->
        <div class="contact-now" @click="handleCode">在线咨询</div>
        <div id="contact-us" v-if="codeIsShow">
            <div>添加微信</div>
            <img class="image" src="../assets/img/weixin.png">
            <div class="author">
                <div>手机号</div>
                <div>18976205160</div>
                <div style="margin-top: 15px">
                    <a style="color: #ffffff; font-size: 14px" target="_blank" href="#">留言反馈</a>
                </div>
            </div>
        </div>

        <!-- 回到顶部 -->
        <div id="to-top">
            <img src="../assets/img/top.svg" @click="topFunction()" alt="回到顶部"/>
        </div>

        <!-- 源码下载 -->
        <Download v-if="this.$store.state.contentType == 0" @handleToggleTab="handleToggleTab"/>
        <!-- 首页 -->
        <Home v-if="this.$store.state.contentType == 1" @handleToggleTab="handleToggleTab"/>
        <!-- 演示系统 -->
        <Sys v-if="this.$store.state.contentType == 2" @handleToggleTab="handleToggleTab"/>
        <!-- 文档中心 -->
        <Document v-if="this.$store.state.contentType == 3" @handleToggleTab="handleToggleTab"/>
        <!-- 安装服务 -->
        <Installs v-if="this.$store.state.contentType == 4" @handleToggleTab="handleToggleTab"/>
        <!-- 登录 -->
        <Login v-if="this.$store.state.contentType == 5" @handleToggleTab="handleToggleTab"/>
        <!-- 注册 -->
        <register v-if="this.$store.state.contentType == 6" @handleToggleTab="handleToggleTab"/>
        <!-- 忘记密码 -->
        <forgetPd v-if="this.$store.state.contentType == 7" @handleToggleTab="handleToggleTab"/>

        <!-- 底部 -->
        <Footer @handleToggleTab="handleToggleTab"/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import allThead from "@/components/allThead.vue";
    import Installs from "@/components/install.vue";
    import Home from "@/components/home.vue";
    import Document from "@/components/document.vue";
    import Sys from "@/components/sys.vue";
    import Login from "@/components/login.vue";
    import Register from "@/components/register.vue";
    import ForgetPd from "@/components/forgetPd.vue";
    import Footer from "@/components/footer.vue";
    import Download from "@/components/download.vue";

    export default {
        name: "Index",
        components: {
            allThead,
            Installs,
            Home,
            Document,
            Sys,
            Login,
            Register,
            ForgetPd,
            Footer,
            Download
        },
        data() {
            return {
                title: [
                    {
                        name: "HOME",
                        id: 1,
                        active: "titleCssClass"
                    },
                    {
                        name: "源码授权",
                        id: 0,
                        active: ""
                    },
                    {
                        name: "演示系统",
                        id: 2,
                        active: ""
                    },
                    {
                        name: "文档中心",
                        id: 3,
                        active: ""
                    },
                    {
                        name: "安装服务",
                        id: 4,
                        active: ""
                    }
                ],
                codeIsShow: false,
            };
        },
        methods: {
            handleToggleTab(id) {
                this.getUser(id);
                this.$store.commit('setContentType', id);
                this.title.forEach(function (e) {
                    if (e.id == id) {
                        e.active = 'titleCssClass'
                    } else {
                        e.active = ''
                    }
                })
            },
            getUser(id) {
                let token = this.$store.state.token;
                if(token == '' || token == null){
                    token = localStorage.getItem("user_token");
                    this.$store.commit('setUserName', '');
                    this.$store.commit('setToken', '');
                }
                this.$http({
                    method: 'post',
                    data:{},
                    url: '/hapi/mhWeb/webOne/getUserInfo?pageId='+id
                }).then(res => {
                    if (res.data.code == 0) {

                    } else {
                        this.$store.commit('setUserName', '');
                        this.$store.commit('setToken', '');
                        localStorage.removeItem("user_token");
                        localStorage.removeItem("username");
                    }
                })
            },
            handleLogin() {
                this.handleToggleTab(5)
            },
            // 是否显示二维码
            handleCode() {
                this.codeIsShow = !this.codeIsShow
            },
            // 滚动到顶部
            topFunction() {
                let top = document.documentElement.scrollTop || document.body.scrollTop;
                // 实现滚动效果
                const timeTop = setInterval(() => {
                    document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                    if (top <= 0) {
                        clearInterval(timeTop);
                    }
                }, 10);
            }
        },
        created() {
            this.getUser(this.$store.state.contentType);
        }
    };
</script>

<style>
    .Index {
        width: 100vw;
    }
</style>




